import React from 'react';
import { ParallaxList } from './parallax-list';

export const IntroSection = () => (
  <>
    <p>
      I’m Asher Lim. A passionate Software Developer and Computer Science
      graduate from Singapore, currently based in Stockholm, Sweden.
    </p>
    <p>
      I build web and server-side applications with JavaScript, React, Java and
      other libraries and frameworks.
    </p>
    <ParallaxList />
  </>
);
